module.exports = __webpack_public_path__ + "static/img/A65.6a303c86.jpg";